import axios from 'axios';
import { constant } from '../constant';

export const postApi = async (path, data) => {
  try {
    let result = await axios.post(constant.baseUrl + path, data, {
      headers: {
        token: localStorage.getItem('token') || sessionStorage.getItem('token')
      }
    });
    if (result) {
      return result;
    } else {
      return false;
    }
  } catch (e) {
    console.error('error found : ', e);
    if (e.response.status === 401 && e.response.data.hotelstatus === false) {
      console.log('Authentication failed. Redirecting to login...');

      localStorage.removeItem('token');
      localStorage.removeItem('hotelData');

      window.location.replace('/login');
    }
    return e;
  }
};
export const patchApi = async (path, data) => {
  try {
    let result = await axios.patch(constant.baseUrl + path, data, {
      data: data?.roomNo,
      headers: {
        token: localStorage.getItem('token') || sessionStorage.getItem('token')
      }
    });
    return result;
  } catch (e) {
    console.error('error found : ', e);
    if (e.response.status === 401 && e.response.data.hotelstatus === false) {
      console.log('Authentication failed. Redirecting to login...');

      localStorage.removeItem('token');
      localStorage.removeItem('hotelData');

      window.location.replace('/login');
    }
    return e;
  }
};

export const deleteApi = async (path, id) => {
  try {
    let result = await axios.delete(constant.baseUrl + path + id, {
      headers: {
        token: localStorage.getItem('token') || sessionStorage.getItem('token')
      }
    });

    return result;
  } catch (e) {
    console.error('error found : ', e);
    if (e.response.status === 401 && e.response.data.hotelstatus === false) {
      console.log('Authentication failed. Redirecting to login...');

      localStorage.removeItem('token');
      localStorage.removeItem('hotelData');

      window.location.replace('/login');
    }
    return e;
  }
};

export const deleteManyApi = async (path, data) => {
  try {
    let result = await axios.post(constant.baseUrl + path, data, {
      headers: {
        token: localStorage.getItem('token') || sessionStorage.getItem('token')
      }
    });
    if (result.data?.token && result.data?.token !== null) {
      localStorage.setItem('token', result.data?.token);
    }
    return result;
  } catch (e) {
    console.error('error found : ', e);
    if (e.response.status === 401 && e.response.data.hotelstatus === false) {
      console.log('Authentication failed. Redirecting to login...');

      localStorage.removeItem('token');
      localStorage.removeItem('hotelData');

      window.location.replace('/login');
    }
    return e;
  }
};

export const getApi = async (path, id) => {
  try {
    if (id) {
      console.log('in getApi id =========> ', id);
      let result = await axios.get(constant.baseUrl + path + id, {
        headers: {
          token: localStorage.getItem('token') || sessionStorage.getItem('token')
        }
      });
    
      return result;
    } else {
      let result = await axios.get(constant.baseUrl + path, {
        headers: {
          token: localStorage.getItem('token') || sessionStorage.getItem('token')
        }
      });
      return result;
    }
  } catch (e) {
    console.error('error found : ', e);
    if (e.response.status === 401 && e.response.data.hotelstatus === false) {
      console.log('Authentication failed. Redirecting to login...');

      localStorage.removeItem('token');
      localStorage.removeItem('hotelData');

      window.location.replace('/login');
    }
    return e;
  }
};
